'use client';

import Image from 'next/image';
import Link from 'next/link';
import { FaRegCircleCheck } from 'react-icons/fa6';

import useSessionStorageInfo from '@/hooks/useSessionStorageInfo';
import { useTranslations } from '@/hooks/useTranslations';
import { Button } from '@/components/ui/button';

const OTPSuccess = () => {
  const { translations } = useTranslations('auth_page');
  const login = translations?.login || 'Login';
  const signup_success_greeting =
    translations?.signup_success_greeting || 'Hi David Rodriguez';
  const signup_success_title =
    translations?.signup_success_title || 'You have signed up successfully';
  const signup_success_description =
    translations?.signup_success_description ||
    'You can login to LiveBench and start exploring and evaluating our boards.';

  const { tenantData } = useSessionStorageInfo();

  return (
    <div className="flex h-[calc(100vh-48px)] items-center justify-center overflow-y-auto bg-white">
      <div className="w-[400px] p-[20px]">
        <Image
          width={120}
          height={53}
          src={tenantData?.logo}
          alt={tenantData?.tenantName}
        />

        <div className="my-10">
          <FaRegCircleCheck className="text-green-500" size={50} />
          <p className="mt-3 text-2xl text-zinc-500">
            {signup_success_greeting}
          </p>
          <h1 className="mt-2 text-3xl font-semibold">
            {signup_success_title}
          </h1>
          <p className="mt-4 text-base text-zinc-500">
            {signup_success_description}
          </p>
          <Link href="/">
            <Button className="mt-5" type="submit" size="fullWidth">
              {login}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
export default OTPSuccess;
